import * as React from 'react';
import { Link } from 'react-router-dom';
import bindAllOfThis from "src/utils/BindThisHelper";
import Routes from 'src/core/Routes';
import { PageProps } from 'src/models/common/ComponentProps';

interface ProdErrorPageProps extends PageProps<{}> {
}

class ProdErrorPage extends React.Component<ProdErrorPageProps> {
    constructor(props: ProdErrorPageProps) {
        super(props);
        bindAllOfThis(this, ProdErrorPage.prototype);
    }

    render() {
        return <div style={{ backgroundColor: "white", padding: 16 }}>
            <div className="row">
                <h1>Whoops!</h1>
                <h4>Looks like you encountered an error! <Link className='navbar-brand' to={Routes.BASE_ROUTE}>Click here to go back to the home screen</Link></h4>
            </div>
        </div>;
    }
}

export default ProdErrorPage;



// WEBPACK FOOTER //
// ./src/pages/public/ProdErrorPage.tsx